import { motion } from "framer-motion";
import { CLIENTS } from "@/data/content";
import { Reveal, MaskLine, SectionLabel, EASE } from "./Reveal";

const ClientCell = ({ name, i }) => (
  <motion.li
    className="group relative flex min-h-[132px] sm:min-h-[168px] items-end bg-[#F6F2E8] p-5 sm:p-7 overflow-hidden"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay: (i % 5) * 0.07, ease: EASE }}
    data-testid={`client-card-${i}`}
  >
    <span className="absolute inset-0 bg-[#16302B] translate-y-full transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:translate-y-0" />
    <span className="absolute top-5 left-5 sm:top-6 sm:left-7 font-display italic text-xs text-[#B8874A] z-10">{String(i + 1).padStart(2, "0")}</span>
    <span className="relative z-10 font-display text-xl sm:text-2xl leading-tight text-[#221F1B] transition-colors duration-500 group-hover:text-white">{name}</span>
  </motion.li>
);

export const Clients = () => (
  <section id="clients" className="relative bg-[#F6F2E8] py-24 sm:py-32 lg:py-40" data-testid="clients-section">
    <div className="max-w-[1320px] mx-auto px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <Reveal><SectionLabel index="III.">Selected Clients</SectionLabel></Reveal>
          <h2 className="font-display mt-8 text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.12] tracking-[-0.015em] text-[#221F1B]" data-testid="clients-headline">
            <MaskLine inView>Founders and teams I've</MaskLine>
            <MaskLine inView delay={0.1} className="italic text-[#16302B]">already partnered with.</MaskLine>
          </h2>
        </div>
        <Reveal className="lg:col-span-5 text-base sm:text-[17px] leading-[1.8] text-[#4A453E]" data-testid="clients-intro">
          Alongside building Glam Studios, I've worked directly with founders across mobility, hospitality, real estate, and beauty — solving product, process, and expansion challenges.
        </Reveal>
      </div>
      <ul className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-[#D8CFBC] border border-[#D8CFBC]" data-testid="clients-grid">
        {CLIENTS.map((c, i) => <ClientCell key={c} name={c} i={i} />)}
      </ul>
      <Reveal as="p" className="mt-8 max-w-3xl text-[13px] leading-relaxed text-[#5C564E]" data-testid="clients-note">
        This list reflects direct consulting relationships — engagements ranged from product and process work to expansion planning, tailored to each company's stage.
      </Reveal>
    </div>
  </section>
);
